import { NavItem } from '../types/content';

export const navItems: NavItem[] = [
  { label: 'Projets', path: '/projets', soon: true },
  { label: 'L’Atelier', path: '/atelier', soon: true },
  { label: 'Contact & Devis', path: '/contact', soon: true },
];
